// Accordion
let accordions = document.querySelectorAll('.accordion');

function deactivateSiblings() {
	for (const accordion of accordions) {
		accordion.classList.remove('active');
	}
}

for (let i = 0; i < accordions.length; i++) {
	let accordion = accordions[i];
	let accordionBtn = accordion.querySelector('.accordion__header');
	accordionBtn.addEventListener('click', function() {
		if (accordion.classList.contains('active')) {
			accordion.classList.remove('active');
		} else {
			deactivateSiblings();
			accordion.classList.add('active');
		}
	});
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

let baseUrl = window.location.origin;

const mainHeader = document.querySelector('.header');
const childrenedLink = mainHeader.querySelectorAll('.menu-item-has-children > a');
const navbarMenu = mainHeader.querySelector('.js-header__nav');
const burgerMenu = mainHeader.querySelector('.js-header__trigger');
const overlayMenu = mainHeader.querySelector('.header__overlay');
const menuItems = mainHeader.querySelectorAll('.menu-item a');

// MENU TITLE

var menuItem = document.querySelectorAll('.menu-item a');

for(let i = 0; i < menuItems.length; i++ ) {
  let menuItem = menuItems[i];
	var innerContent = menuItem.innerHTML;
	menuItem.setAttribute("title", innerContent);
}

// SUB-MENU

// Menu title
for(let i = 0; i < menuItems.length; i++ ) {
  let menuItem = menuItems[i];
	var innerContent = menuItem.innerHTML;
	menuItem.setAttribute("title", innerContent);
}

// insertAfter
let insertAfter = (newNode, existingNode) => {
  existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
}

// Guess what it does
let removeHash = () => { 
  history.replaceState(null, null, ' ');
}

// Insert button after link with children
let injectAfter = (newNode, existingNode) => {
	existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
}

// Remove "active" class for menu-has-children siblings
let disableAllSiblings = (currIndex) => {
  for(let i = 0; i < childrenedLink.length; i++) {
		if(i != currIndex) {
			childrenedLink[i].parentNode.classList.remove('active');
		}
	}
}

// Add button to sub menu
let subMenu = () => {

  for(let i = 0; i < childrenedLink.length; i++) {
		let thisLink = childrenedLink[i];
		let btn = document.createElement('button');
		btn.classList.add('menu-toggler');
		injectAfter(btn, thisLink);
		btn.addEventListener('click', function() {
			let parent = btn.parentNode;
			disableAllSiblings(i);
			parent.classList.toggle('active');
		});
  }

}

subMenu();

// Toggle Menu Function
burgerMenu.addEventListener('click', toggleMenu);

function toggleMenu() {
	navbarMenu.classList.toggle('active');
	overlayMenu.classList.toggle('active');
	burgerMenu.classList.toggle('active');
}

let blockGlideParent = () => {
	let columns = document.querySelectorAll('.wp-block-columns');
	//Display block parent
	for( let i = 0; i < columns.length; i++) {
		let glide = columns[i].querySelector('.glide');
		if (columns[i].contains(glide)) {
			columns[i].classList.add('is-block');
		}
	}
}

let fixGlideAnim = (sliderName, sliderElement) => {

  //bullets
	let firstBullet = sliderName.querySelector('.glide__bullet:first-child');
	let bullets = sliderName.querySelectorAll('.glide__bullet');

	firstBullet.classList.add('glide__bullet--really-active');

	sliderElement.on('move', () => {
		let moveIndex = sliderElement.index;
		for( let i = 0; i < bullets.length; i++) {
			let bullet = bullets[i];
			let currBullet = bullets[moveIndex];
			bullet.classList.remove('glide__bullet--really-active');
			currBullet.classList.add('glide__bullet--really-active');
		}
	});

}
let glideResize = (sliderName, sliderElement) => {

	let toggleFunc = () => {
		let windowSize = window.innerWidth;
		if (windowSize >= 1024) {
			sliderElement.disable();
		} else {
			sliderElement.enable();
		}
	}

	let resizeFunc = debounce(function() {
		toggleFunc();
	}, 250);

	if (sliderName.hasAttribute('data-tablet', 'true')) {
		toggleFunc();
		window.addEventListener("resize", resizeFunc);
	}

};

// Popup

let displayPopUp = () => {

	let popUp = document.querySelector('.popup');
	let popUpBtn = popUp.querySelector('.popup__btn');

	popUp.classList.add('active');
	setTimeout(() => {
		popUp.classList.add('visible');
	}, 100);

	popUpBtn.addEventListener('click', () => {
		popUp.classList.remove('visible');
		setTimeout(() => {
			popUp.classList.remove('active');
		}, 300);
	});

}

let doPopupOnce = () => {

	let doSession = sessionStorage.getItem("showPopUp", true);

	if (!doSession) {
		sessionStorage.setItem("showPopUp", true);
		displayPopUp();
	}

}

//DOM load
document.addEventListener("DOMContentLoaded", function(event) {

	// Display Popup only on the current session
	doPopupOnce();

	blockGlideParent();

	let carouselExpert = document.querySelector('.glide-expertise');
	let carouselAnnonces = document.querySelector('.glide-annonces');
	let carouselHome = document.querySelector('.glide-home');
	
  if (typeof(carouselExpert) != 'undefined' && carouselExpert != null) {
    let glideExpert = new Glide('.glide-expertise', {
      type: 'carousel',
      autoplay: 6000,
      animationDuration: 1000,
    }).mount();
    fixGlideAnim(carouselExpert, glideExpert);
		glideResize(carouselExpert, glideExpert);
	}

	if (typeof(carouselAnnonces) != 'undefined' && carouselAnnonces != null) {
    let glideAnnonces = new Glide('.glide-annonces', {
      type: 'carousel',
      autoplay: 6000,
      animationDuration: 1000,
    }).mount();
    fixGlideAnim(carouselAnnonces, glideAnnonces);
		glideResize(carouselAnnonces, glideAnnonces);
	}

	if (typeof(carouselHome) != 'undefined' && carouselHome != null) {
    let glideHome = new Glide('.glide-home', {
      type: 'carousel',
      autoplay: 6000,
      animationDuration: 1000,
    }).mount();
    fixGlideAnim(carouselHome, glideHome);
		// glideResize(carouselAnnonces, glideAnnonces);
	}


	/* Annonce - single Glide */
	let checkAnnonce = document.querySelector(".glide-annonce");
	if (typeof(checkAnnonce) != 'undefined' && checkAnnonce != null) {

		let slider1 = new Glide('.glide-annonce--1', {
			perView:1,
			autoplay: 3000
		}).mount();
		
		let slider2 = new Glide('.glide-annonce--2', {
			perView: 4,
			peek :{ 
				before: 0,
				after: 50
			},
			bound: true
		}).mount();

		let btnPrev = document.querySelector('.glide-annonce__btn--prev');
		let btnNext = document.querySelector('.glide-annonce__btn--next');
		
		Array.from(document.querySelectorAll('.slide-nav')).forEach(el => {
			el.addEventListener('click', (e) => {
				slider1.go('='+(el.dataset.index))
				slider2.go('='+(el.dataset.index))
			});
		});
		
		slider1.on('swipe.end', function() {
			slider2.go('='+(slider1.index));
		});
		
		slider1.on('move.after', function() {
			slider2.go('='+(slider1.index));
		});

	}

	let vignettesExists = document.querySelector('.vignettes__splide');

	if (typeof(vignettesExists) != 'undefined' && vignettesExists != null) {
		let carouselVignettes = new Splide( vignettesExists, {
			type: 'loop',
			arrows: false,
			pagination: false,
			perPage: 1,
			perMove: 1,
			focus: 0,
			speed: 1000,
			interval: 5000,
			autoplay: true,
			snap: true,
			easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
			mediaQuery: "min",
			breakpoints: {
				1024: {
					destroy: true
				}
			},
		} );

		carouselVignettes.mount();
	}

	let testimoniesExists = document.querySelector('.testimonies__splide');

	if (typeof(testimoniesExists) != 'undefined' && testimoniesExists != null) {
		let carouselTestimonies = new Splide( testimoniesExists, {
			type: 'loop',
			arrows: false,
			pagination: false,
			perPage: 1,
			perMove: 1,
			focus: 0,
			speed: 1000,
			interval: 5000,
			autoplay: true,
			snap: true,
			easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
			mediaQuery: "min",
			breakpoints: {
				1024: {
					destroy: true
				}
			},
		} );

		carouselTestimonies.mount();
	}

	let galleryExists = document.querySelector('.gallery__splide');

	if (typeof(galleryExists) != 'undefined' && galleryExists != null) {
		let carouselGallery = new Splide( galleryExists, {
			type: 'loop',
			arrows: true,
			pagination: false,
			perPage: 1,
			perMove: 1,
			focus: 0,
			speed: 1000,
			interval: 5000,
			autoplay: true,
			snap: true,
			easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
			arrowPath: 'M 4.800781 6.402344 L 14.398438 16 L 4.800781 25.601562 L 11.199219 32 L 27.199219 16 L 11.199219 0 Z M 4.800781 6.402344 ',
			mediaQuery: "min",
			breakpoints: {
				1024: {
					destroy: true
				}
			},
		} );

		carouselGallery.mount();
	}

	// PICTURES SLIDER
	let sliderPictures = document.querySelector('.splide-pictures');

	if (typeof sliderPictures != 'undefined' && sliderPictures != null) {
		let splidePictures = new Splide( sliderPictures, {
			type: 'loop',
			arrows: true,
			pagination: false,
			perPage: 1,
			perMove: 1,
			focus: 0,
			speed: 1000,
			snap: true,
			easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
			arrowPath: 'M 4.800781 6.402344 L 14.398438 16 L 4.800781 25.601562 L 11.199219 32 L 27.199219 16 L 11.199219 0 Z M 4.800781 6.402344 ',
			mediaQuery: "min",
			breakpoints: {
				1024: {
					destroy: true,
				},
			}
		});
		splidePictures.mount();
	};

}); //end of DOM load

function collapseSubMenu() {
	navbarMenu.querySelector('.menu-item-has-children.active .sub-menu').removeAttribute('style');
	navbarMenu.querySelector('.menu-item-has-children.active').classList.remove('active');
}

// Fixed Resize Screen Function
window.addEventListener('resize', () => {
	if (window.innerWidth > 992) {
		// If navbarMenu is Open, then Close It
		if (navbarMenu.classList.contains('active')) {
			toggleMenu();
		}

		// If menu-item-child is Expanded, then Collapse It
		if (navbarMenu.querySelector('.menu-item-has-children.active')) {
			collapseSubMenu();
		}
	}
});

// SCROLL-RELATED FUNCTIONS

/* Animate on scroll */
let scrollOffset = 100;
let scrollElements = document.querySelectorAll(".js-scroll");

//initialize throttleTimer as false
let timerOne, timerTwo, timerThree = false;
 
let throttle = function(callback, throttleTimer, time) {

    //don't run the function while throttle timer is true
    if (throttleTimer) return;
     
    //first set throttle timer to true so the function doesn't run
    throttleTimer = true;
     
    setTimeout(function() {
        //call the callback function in the setTimeout and set the throttle timer to false after the indicated time has passed 
        callback();
        throttleTimer = false;
    }, time);
}

var elementInView = function(el, offset) {
  var offset = 0;
  var elementTop = el.getBoundingClientRect().top;
 
  return (
    elementTop <= 
    ((window.innerHeight || document.documentElement.clientHeight) - offset)
  );
};

var elementOutofView = function(el) {
  var elementTop = el.getBoundingClientRect().top;

  return (
    elementTop > (window.innerHeight || document.documentElement.clientHeight)
  );
};

var displayScrollElement = function(element) {
  element.classList.add("scrolled");
};

var hideScrollElement = function(element) {
  element.classList.remove("scrolled");
};
 
var handleScrollAnimation = function() {
  scrollElements.forEach(function(el) {
    if (elementInView(el, 1.25)) {
      displayScrollElement(el);
    } else if (elementOutofView(el)) {
      hideScrollElement(el)
    }
  })
}

/* STEPS BAR */

let stepsBarHeight= () => {
	if (typeof(document.querySelector(".steps__bar")) != 'undefined' && document.querySelector(".steps__bar") != null) {

	let stepButtons = document.querySelectorAll(".steps__btn");

	for(let i = 0; i < stepButtons.length; i++ ) {
		stepButtons[i].addEventListener("click", (e) => {
			let stepButton = stepButtons[i];
			stepButton.parentNode.classList.toggle('active');
		});
	}
	
	let stepBlocks = document.querySelectorAll(".steps__block");
	let stepBlocksLength = stepBlocks.length;

	let stepBar = document.querySelector(".steps__bar");
	let stepBarInner = document.querySelector(".steps__bar__inner");
	let stepBarHeight = stepBar.parentNode.offsetHeight - (stepBar.parentNode.offsetHeight / stepBlocksLength);
	let stepBarTop = stepBar.getBoundingClientRect().top;
	// let stepBarBottom = stepBarTop + stepBarHeight;

	stepBar.style.height = stepBarHeight + "px";

	let scrollStep = () => {
		let top  = window.pageYOffset || document.documentElement.scrollTop;
		let trigger = Math.round(top + window.innerHeight);
		let stepBarProgress = Math.round((window.pageYOffset + (window.innerHeight / 2) - stepBarTop));
		if (trigger > stepBarTop) {
			stepBarInner.style.height = stepBarProgress + "px";
		}
	}

	window.addEventListener('scroll', function() {
		throttle(scrollStep, false, 100);
	});

	};
}

stepsBarHeight();

let resizeSteps = debounce(function() {
	stepsBarHeight();
}, 250);

window.addEventListener("resize", resizeSteps);

/* Sticky menu */
let header = document.querySelector(".header");
let headerHeight = header.offsetHeight;
let flag = false;
let sticker = document.querySelector(".sticker");

let stickyMenu = () => {
	var posCurseur = window.scrollY;

	if(posCurseur < headerHeight){
		header.classList.remove('sticky');
		header.classList.remove('invisible');
		flag = false;
	} else if(posCurseur > headerHeight) {
		if (flag == false) {
			header.classList.add('invisible');
			setTimeout(() => {
				header.classList.add('sticky');
			}, 300);
			flag = true;
		} else {
			setTimeout(() => {
			header.classList.remove('invisible');
		}, 300);
		}
	}
}

/* Sticker */
let stickerMove = () => {
	if (typeof(sticker) != 'undefined' && sticker != null) {

		setTimeout(() => {
			sticker.classList.add('animated');
		}, 300);
		sticker.classList.remove('animated');

		if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight) {
			sticker.classList.add("invisible");
			setTimeout(() => {
				sticker.classList.add('deleted');
			}, 300);
		} else {
			sticker.classList.remove('deleted');
			setTimeout(() => {
				sticker.classList.remove('invisible');
			}, 300);
		}
	};

}
 
window.addEventListener('scroll', function() {
	throttle(stickyMenu, timerOne, 250);
	throttle(stickerMove, timerTwo, 250);
  throttle(handleScrollAnimation, timerThree, 250);
});
